export default __webpack_public_path__ + "assets/5bafcb74d86d02b91617388b3c493939.svg";